import { Injectable } from '@angular/core';
import { BaseErrorMappingService } from '../base-error-mapping.service';
import type { ErrorRule } from '../../../models/error-mapping.model';

@Injectable({
  providedIn: 'root'
})
export class AuthErrorMappingService extends BaseErrorMappingService {
  protected rules: ErrorRule[] = [
    {
      pattern: /\/B2CLogin/,
      messages: {
        400: 'errors.signInFailed',
        404: 'errors.signInFailed',
        500: 'errors.signInFailed',
        success: {
          INVALID_CREDENTIALS: 'signIn.invalidCredentials',
          default: 'errors.signInIncorrect'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/B2cSignUp/,
      messages: {
        400: 'errors.signUpFailed',
        404: 'errors.signUpFailed',
        500: 'errors.signUpFailed',
        success: {
          MULTIPLE_RECORDS: 'errors.signUpMultipleRecords',
          default: 'errors.signUpIncorrect'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/B2cRefresh/,
      messages: {
        400: 'errors.tokenRefreshFailed',
        404: 'errors.tokenRefreshFailed',
        500: 'errors.tokenRefreshFailed',
        success: {
          default: 'errors.tokenRefreshFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/CheckPasswordAccessLink/,
      messages: {
        400: 'errors.checkPasswordAccessLinkFailed',
        404: 'errors.checkPasswordAccessLinkFailed',
        500: 'errors.checkPasswordAccessLinkFailed',
        success: {
          default: 'errors.checkPasswordAccessLinkFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/B2cChangePassword/,
      messages: {
        400: 'errors.b2cChangePasswordFailed',
        404: 'errors.b2cChangePasswordFailed',
        500: 'errors.b2cChangePasswordFailed',
        success: {
          default: 'errors.b2cChangePasswordFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/SendPasswordAccessLink/,
      messages: {
        400: 'errors.sendPasswordAccessLinkFailed',
        404: 'errors.sendPasswordAccessLinkFailed',
        500: 'errors.sendPasswordAccessLinkFailed',
        success: {
          default: 'errors.sendPasswordAccessLinkFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    },
    {
      pattern: /\/PasswordReset/,
      messages: {
        400: 'errors.passwordResetFailed',
        404: 'errors.passwordResetFailed',
        500: 'errors.passwordResetFailed',
        success: {
          default: 'errors.passwordResetFailed'
        }
      },
      options: {
        showInInterceptor: true,
        duration: 5000
      }
    }
  ];
}
